import { c as _c } from "react/compiler-runtime";
import React, { FC } from 'react';
import { PlantingGraph } from '.';
import { MockGraphCover } from '@app/_components/lf-graph/MockGraphCover';
const mockData = [{
  label: 'January',
  created: 381263,
  planted: 49869,
  not_planted: 0,
  harvested: 198927,
  ready_to_harvest: 0,
  year: '2024'
}, {
  label: 'February',
  created: 498000,
  planted: 25708,
  not_planted: 0,
  harvested: 179789,
  ready_to_harvest: 0,
  year: '2024'
}, {
  label: 'March',
  created: 493638,
  planted: 190024,
  not_planted: 0,
  harvested: 196375,
  ready_to_harvest: 0,
  year: '2024'
}, {
  label: 'April',
  created: 299011,
  planted: 297409,
  not_planted: 0,
  harvested: 99210,
  ready_to_harvest: 234234,
  year: '2024'
}, {
  label: 'May',
  created: 496415,
  planted: 288434,
  not_planted: 0,
  harvested: 170658,
  ready_to_harvest: 0,
  year: '2024'
}, {
  label: 'June',
  created: 17368,
  planted: 44029,
  not_planted: 0,
  harvested: 126475,
  ready_to_harvest: 0,
  year: '2024'
}, {
  label: 'July',
  created: 38530,
  planted: 12225,
  not_planted: 0,
  harvested: 24400,
  ready_to_harvest: 0,
  year: '2024'
}, {
  label: 'August',
  created: 32399,
  planted: 16484,
  not_planted: 0,
  harvested: 33545,
  ready_to_harvest: 123444,
  year: '2024'
}, {
  label: 'September',
  created: 328433,
  planted: 31,
  not_planted: 0,
  harvested: 172014,
  ready_to_harvest: 1000,
  year: '2024'
}, {
  label: 'October',
  created: 432813,
  planted: 201592,
  not_planted: 0,
  harvested: 177229,
  ready_to_harvest: 0,
  year: '2024'
}, {
  label: 'November',
  created: 260962,
  planted: 185373,
  not_planted: 0,
  harvested: 64338,
  ready_to_harvest: 0,
  year: '2024'
}, {
  label: 'December',
  created: 174224,
  planted: 123777,
  not_planted: 0,
  harvested: 48888,
  ready_to_harvest: 0,
  year: '2024'
}];
export const MockPlantingGraph: FC<{
  title: string;
}> = t0 => {
  const $ = _c(3);
  const {
    title
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <PlantingGraph data={mockData} mock={true} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <MockGraphCover coverText={title}>{t1}</MockGraphCover>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};